import { TipoDeAsociado, TipoDeDoc, Sexo } from "../../../isp.žapi.asociados/constantesApiAsociados";

const tiposAsociado = [
    { label: "Con Doc. de Identidad", value: TipoDeAsociado.DocId },
    { label: "Con RUC", value: TipoDeAsociado.RUC },
];

const tiposDoc = [
    { label: "DNI", value: TipoDeDoc.DNI },
    { label: "Pasaporte", value: TipoDeDoc.PASSPORT },
    { label: "PTP", value: TipoDeDoc.PERMISO_TEMP_PERM },
    { label: "Carnet de Extranjería", value: TipoDeDoc.CARNET_EXT },
];

const tiposSexo = [
    { label: "Masculino", value: Sexo.Masculino },
    { label: "Femenino", value: Sexo.Femenino },
];

const modosCobro = [
    { label: "Exonerado", value: "exo" },
    { label: "Asociado", value: "asociado" },
];
const tiposComprobantes = [
    { label: "Recibo de Venta", value: "rv" },
    { label: "Factura", value: "fac" },
    { label: "Boleta", value: "bol" },
];
const ciclosFact = [
    { label: "15 del mes", value: "15m" },
    { label: "Último dia del mes", value: "udiam" },
];

export { tiposAsociado, tiposDoc, tiposSexo, modosCobro, tiposComprobantes, ciclosFact };
